// Fetches the 'global' CMS page-content and the countries list exactly
// once per app load, at the top of the tree, and hands them out via
// context. Navbar, Footer and AboutUs all need 'global' content; Navbar
// and HeroSection both need countries. Without this each of those
// components fetched independently — cache.js's in-flight dedupe already
// collapses simultaneous calls into one network request, but this removes
// the duplicate fetch *code* too and gives every consumer the same values
// on the same render pass, rather than each waiting on its own promise.
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getPageContentFlat, getCountries } from '../services/api';

const SiteContentContext = createContext(undefined);

export function SiteContentProvider({ children }) {
  const [globalContent, setGlobalContent] = useState({});
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getPageContentFlat('global')
      .then(setGlobalContent)
      .catch(() => {});
    getCountries()
      .then((data) => setCountries(Array.isArray(data) ? data : (data.results || data)))
      .catch(() => {});
  }, []);

  return (
    <SiteContentContext.Provider value={{ globalContent, countries }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  const ctx = useContext(SiteContentContext);
  if (!ctx) {
    throw new Error('useSiteContent must be used within a SiteContentProvider');
  }
  return ctx;
}
